import React from 'react';
import {
	MultiList,
	RatingsFilter,
	ReactiveComponent,
	SingleList,
	RangeSlider,
} from '@appbaseio/reactivesearch';
import { css } from '@emotion/css';

import ListComponent from './ListComponent';
import SelectComponent from './SelectComponent';

const filterStyles = css`
	margin: 20px 10px;
	padding: 10px;
	border: 1px solid #eaeaea;
	background: white;
	width: 280px;
	@media (max-width: 576px) {
		margin: 20px 0px;
		padding: 10px;
	}
`;

const sliderStyles = css`
	.rheostat-progress {
		background-color: #174ff4 !important;
	}
	.rheostat-handle {
		border-color: #bfbfbf !important;
	}
`;

/*
	This component define all the filters placed in Sider and Drawer in Search Page.
	Note: We are using ReactiveComponent to Generate custom List and Dropdown Component.
*/

const Filters = () => (
	<React.Fragment>
		<ReactiveComponent
			componentId="Authors"
			defaultQuery={() => ({
				...MultiList.generateQueryOptions({ dataField: 'authors.keyword', size: 50 }),
			})}
			selectComponentProps={{
				placeholder: 'Select Authors',
			}}
			render={({ aggregations, value, setQuery }) => (
				<SelectComponent
					dataField="authors.keyword"
					dataKey="Authors"
					aggregations={aggregations}
					selectedValue={value}
					setQuery={setQuery}
				/>
			)}
		/>

		<ReactiveComponent
			defaultQuery={() => ({
				...SingleList.generateQueryOptions({
					dataField: 'original_series.keyword',
					size: 50,
				}),
			})}
			componentId="Series"
			render={({ aggregations, value, setQuery }) => (
				<ListComponent
					dataField="original_series.keyword"
					dataKey="Series"
					title="Select Book Series"
					aggregations={aggregations}
					selectedValue={value}
					setQuery={setQuery}
				/>
			)}
		/>

		<RangeSlider
			className={filterStyles}
			tooltipTrigger="hover"
			title="Publication Year"
			dataField="original_publication_year"
			componentId="Year"
			range={{ start: 1950, end: 2019 }}
			innerClass={{
				slider: sliderStyles,
			}}
		/>

		<RatingsFilter
			componentId="Ratings"
			dataField="average_rating"
			title="RatingsFilter"
			className={filterStyles}
			data={[
				{ start: 4, end: 5, label: '4 stars and up' },
				{ start: 3, end: 5, label: '3 stars and up' },
				{ start: 2, end: 5, label: '2 stars and up' },
				{ start: 1, end: 5, label: '> 1 stars' },
			]}
		/>
	</React.Fragment>
);

export default Filters;
